import { selectRosters } from '@src/data/business/Rosters/selectors'
import {
  ACCEPTANCE_CRITERIA_OPTION,
  IAcceptanceCriteriaFormValues,
} from '@src/features/shift-post-v2/steps/acceptance-criteria-step/acceptance-criteria-step.types'
import { useDefaultRosterIds } from '@src/features/shift-post-v2/utils/roster-defaults.utils'
import { IDropdownData } from '@src/models/Common'
import { FormikProps } from 'formik'
import { useSelector } from 'react-redux'

export const useSelectedOption = (
  formik: FormikProps<IAcceptanceCriteriaFormValues>,
  setSelectedRosters: (selected: IDropdownData[]) => void,
) => {
  const { setFieldValue, values, setValues, validateField } = formik
  const rosters = useSelector(selectRosters)
  const defaultRosterIds = useDefaultRosterIds()

  const handleSelectedOptionChange = (value: number) => {
    switch (value) {
      case ACCEPTANCE_CRITERIA_OPTION.VERIFIED_FROM_ROSTERS:
        const selectedRosters = rosters.filter(roster =>
          values.roster_ids.includes(roster.id),
        )
        // set auto_accept_rosters if there are any selected rosters from prev acceptance criteria option
        if (selectedRosters.length > 0) {
          setValues(prev => ({
            ...prev,
            auto_accept_rosters: selectedRosters,
            auto_accept_roster_ids: selectedRosters.map(r => r.id),
            auto_accept_by_rosters: true,
            auto_accept: true,
          }))

          setSelectedRosters(
            selectedRosters.map(roster => ({
              value: roster.id,
              label: roster.name,
            })),
          )

          // otherwise set auto_accept_rosters to default rosters, so default rosters are preselected for the user
        } else if (defaultRosterIds.length > 0) {
          setValues(prev => ({
            ...prev,
            auto_accept_rosters: defaultRosterIds,
            auto_accept_roster_ids: defaultRosterIds.map(r => r.id),
            roster_ids: defaultRosterIds.map(r => r.id),
            auto_accept_by_rosters: true,
            auto_accept: true,
          }))

          setSelectedRosters(
            defaultRosterIds.map(roster => ({
              value: roster.id,
              label: roster.name,
            })),
          )
        } else {
          setValues(prev => ({
            ...prev,
            auto_accept_by_rosters: true,
            auto_accept: true,
          }))
        }
        break

      case ACCEPTANCE_CRITERIA_OPTION.VERIFIED:
        setValues(prev => ({
          ...prev,
          auto_accept_by_rosters: false,
          auto_accept_rosters: [],
          auto_accept_roster_ids: [],
          auto_accept: true,
        }))

        setSelectedRosters([])
        break

      case ACCEPTANCE_CRITERIA_OPTION.PERSONALLY_APPROVED:
        setValues(prev => ({
          ...prev,
          auto_accept_by_rosters: false,
          auto_accept_rosters: [],
          auto_accept_roster_ids: [],
          auto_accept: false,
        }))

        setSelectedRosters([])
        break

      default:
        break
    }

    // Explicitly validate the form after state update
    setTimeout(() => {
      validateField('auto_accept_roster_ids')
    }, 0)
  }

  return {
    handleSelectedOptionChange,
  }
}
